import { render, staticRenderFns } from "./OrderConfirmedOverlay.vue?vue&type=template&id=3fe18903&scoped=true"
import script from "./OrderConfirmedOverlay.vue?vue&type=script&lang=js"
export * from "./OrderConfirmedOverlay.vue?vue&type=script&lang=js"
import style0 from "./OrderConfirmedOverlay.vue?vue&type=style&index=0&id=3fe18903&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe18903",
  null
  
)

export default component.exports